import React from 'react';
import { useMoney } from '../../hooks';
import { Money } from '../Money';
import { UnitPriceFragment as Fragment } from '../../graphql/graphql-constants';
/**
 * The `UnitPrice` component renders a string with a [UnitPrice](/themes/pricing-payments/unit-pricing) as the
 * [Storefront API's `MoneyV2` object](/api/storefront/reference/common-objects/moneyv2) with a reference unit from the [Storefront API's `UnitPriceMeasurement` object](/api/storefront/reference/products/unitpricemeasurement).
 *
 * If `children` is a function, then it will provide render props for the `children` corresponding to the object
 * returned by the `useMoney` hook and the `UnitPriceMeasurement` object.
 */
export function UnitPrice(props) {
    const { unitPrice, unitPriceMeasurement, children, as, ...passthroughProps } = props;
    const Wrapper = as !== null && as !== void 0 ? as : 'div';
    const unitPriceMoneyObject = useMoney(unitPrice);
    const unitPriceAndMeasurementObject = {
        ...unitPriceMoneyObject,
        ...unitPriceMeasurement,
    };
    return (React.createElement(Wrapper, { ...passthroughProps }, typeof children === 'function' ? (children(unitPriceAndMeasurementObject)) : (React.createElement(React.Fragment, null,
        React.createElement(Money, { money: unitPrice }),
        "/",
        unitPriceMeasurement.referenceUnit))));
}
UnitPrice.Fragment = Fragment;
export const UnitPriceFragment = Fragment;
